import React, { useCallback } from "react";
import PropTypes from "prop-types";
import FormControlTemplate from "../ui/formControlTemplate/FormControlTemplate";

const Label = React.lazy(() => import("../ui/label/Label"));
const Input = React.lazy(() => import("../ui/inputs/input/Input"));
const ValidationText = React.lazy(() =>
  import("../ui/validation/ValidationText")
);

const FormInputFields = ({
  dataField,
  labelName,
  name,
  keyId,
  type,
  value,
  error,
  formSetting,
  overRideProps,
  isRequired,
  fieldSetting,
  onChange,
  onBlure,
  onActionChange,
  inputInfoConfig,
}) => {

  const handleInputChange = useCallback((value) => {
    if (onChange) {
      onChange(dataField, value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange]);

  const handleOnBlur = (dataField, updatedValue) => {
    onBlure?.(dataField, updatedValue);
  };

  const handleButtonClick = (action, data) => {
    onActionChange(action, dataField);
  };

  return (
    <>
      <div className="input-label-part">
        {labelName && labelName !== "" && (
          <Label labelName={labelName} htmlFor={name} isRequired={isRequired} />
        )}
        {fieldSetting?.subTitle ? (
          <div className="section-title">
            <h5>{fieldSetting.subTitle}</h5>
          </div>
        ) : (
          ""
        )}
        <div
          className={`input-top-title ${fieldSetting?.isFormControl ? "input-with-btn" : ""
            } `}
        >
          <Input
            id={name}
            name={name}
            type={type}
            value={value}
            keyId={keyId}
            onChange={handleInputChange}
            onBlur={handleOnBlur}
            inputInfoConfig={inputInfoConfig}
            dataField={dataField}
            isdisable={
              formSetting?.isViewOnly ||
              (overRideProps?.isDisable !== undefined
                ? overRideProps?.isDisable
                : fieldSetting?.isDisable) ||
              false
            }
            isreadonly={
              formSetting?.isReadOnly ||
              (overRideProps?.isReadOnly !== undefined
                ? overRideProps?.isReadOnly
                : fieldSetting?.isReadOnly) ||
              false
            }
            {...fieldSetting}
          />
          {fieldSetting?.isFormControl && (
            <FormControlTemplate
              fieldSetting={fieldSetting}
              handleButtonClick={handleButtonClick}
            />
          )}
        </div>
      </div>
      <ValidationText error={error || ""} />
    </>
  );
};

FormInputFields.propTypes = {
  dataField: PropTypes.string.isRequired,
  labelName: PropTypes.string,
  name: PropTypes.string.isRequired,
  keyId: PropTypes.string,
  type: PropTypes.string.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  formSetting: PropTypes.shape({
    isViewOnly: PropTypes.bool,
    isReadOnly: PropTypes.bool,
  }),
  overRideProps: PropTypes.shape({
    isDisable: PropTypes.bool,
    isReadOnly: PropTypes.bool,
  }),
  isRequired: PropTypes.bool,
  fieldSetting: PropTypes.shape({
    subTitle: PropTypes.string,
    isFormControl: PropTypes.bool,
    debounceTime: PropTypes.number,
    isDisable: PropTypes.bool,
    isReadOnly: PropTypes.bool,
  }),
  onChange: PropTypes.func.isRequired,
  onBlure: PropTypes.func,
  onActionChange: PropTypes.func,
  inputInfoConfig: PropTypes.object,
};

export default React.memo(FormInputFields);
